// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter
            future={{
                v7_startTransition: true, // Para habilitar startTransition en v6
                v7_relativeSplatPath: true, // Para ajustar las rutas splat
            }}
        >      <App />
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
